/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsDisplaysService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type BusinessUnitsChirpError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType = 'NOT_FOUND' | 'BAD_REQUEST' | unhandledEnumCase;

export type RpcBusinessUnitDisplay = {
  id: number;
  hubId: number;
  name: string;
  allUsersHaveAccess: boolean;
  logoUrl?: string;
  logoAltText?: string;
  resizedUrl?: string;
};

export type GetBusinessUnitsByNamesRequest = { names: Default<string[]> };

export type GetBusinessUnitDisplaysResponse = {
  businessUnitDisplays: Default<RpcBusinessUnitDisplay[]>;
};

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GetBusinessUnitDisplaysForUserResponseType =
  GetBusinessUnitDisplaysResponse;
export type GetBusinessUnitDisplaysForUserErrorType = BusinessUnitsChirpError &
  HubspotMetadata;
export const getBusinessUnitDisplaysForUserRpc: ChirpAvroRpcDetails<
  undefined,
  GetBusinessUnitDisplaysForUserResponseType,
  GetBusinessUnitDisplaysForUserErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsDisplaysService',
  rpcName: 'getBusinessUnitDisplaysForUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADMaJU4WVA0tC8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetBusinessUnitDisplaysForUserByNamesRequestType =
  Requestify<GetBusinessUnitsByNamesRequest>;
export type GetBusinessUnitDisplaysForUserByNamesResponseType =
  GetBusinessUnitDisplaysResponse;
export type GetBusinessUnitDisplaysForUserByNamesErrorType =
  BusinessUnitsChirpError & HubspotMetadata;
export const getBusinessUnitDisplaysForUserByNamesRpc: ChirpAvroRpcDetails<
  GetBusinessUnitDisplaysForUserByNamesRequestType,
  GetBusinessUnitDisplaysForUserByNamesResponseType,
  GetBusinessUnitDisplaysForUserByNamesErrorType,
  false
> = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsDisplaysService',
  rpcName: 'getBusinessUnitDisplaysForUserByNames',
  auth: 'app',
  fingerprint: 'YdRnXCf4OILMaJU4WVA0tC8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
